import React from "react";
import under from "../assets/WhatsApp Image 2025-10-18 at 12.45.38.jpeg";

function Shop() {
  return (
    <div
      className="shop-container"
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor: "#000", // prevents white bars when image is smaller
      }}
    >
      <img
        src={under}
        alt="Shop location"
        style={{
          width: "100%",
          height: "auto", // ensures full image shows, scales with width
          display: "block",
          borderRadius: "10px",
        }}
      />

      <div
        className="shop-address"
        style={{
          position: "absolute",
          bottom: "20%",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          color: "#fff",
          padding: "12px 20px",
          borderRadius: "6px",
          fontFamily: "serif",
          fontSize: "1.1rem",
          textAlign: "center",
          width: "90%",
          maxWidth: "700px",
        }}
      >
        Juhu Tara Road, next to Hotel Sea Princess, Airport Area, Juhu, Mumbai,
        Maharashtra 400049
      </div>
    </div>
  );
}

export default Shop;
